import { render, staticRenderFns } from "./EmailRegister.vue?vue&type=template&id=4a502bf8&"
import script from "./EmailRegister.vue?vue&type=script&lang=js&"
export * from "./EmailRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports